import React from "react";
import PageLayout from "../../../components/Layout/PageLayout";

const DataProcessingAddendum: React.FC = () => {
  const termsContent = [
    {
      title: "Data Processing Addendum (DPA)",
      content: (
        <>
          <p className="text-gray-600 mb-4">
            This Data Processing Addendum is subject to the terms of the Master
            Services Agreement between 25th & Staffing ("Provider") and{" "}
            {"Customer"}.
          </p>
          <p className="mb-4">1. Definitions</p>
          <p className="mb-4">
            <b>"Data Protection Laws"</b> means all applicable data privacy and
            protection laws, including (where applicable) the Nigeria Data
            Protection Act (NDPA), the EU General Data Protection Regulation
            (GDPR), and other applicable regional laws.
          </p>
          <p className="mb-4">
            <b>"Personal Data"</b> means any information relating to an
            identified or identifiable natural person, as defined by Data
            Protection Laws, that is part of the Customer Data.
          </p>
          <p className="mb-4">
            <b>"Controller," "Processor," "Data Subject," and "Processing"</b>{" "}
            shall have the meanings given to them in the applicable Data
            Protection Laws.
          </p>
          <p className="mb-4">2. Roles and Scope</p>
          <p className="mb-4">
            <b>2.1. Roles:</b> The Parties agree that for the purposes of this
            DPA, Customer is the Controller and Provider is the Processor of
            Personal Data.
          </p>
          <p className="mb-2">
            <b>2.2. Details of Processing:</b>
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li>
              <b>Subject Matter:</b> The processing of Personal Data related to
              Customer's recruiting and hiring activities.
            </li>
            <li>
              <b>Duration:</b> For the term of the Agreement.
            </li>
            <li>
              <b>Nature and Purpose:</b> To provide the AI Recruiter Services,
              including processing resumes, candidate profiles, interview data,
              and interview feedback to screen, rank, and manage candidates on
              behalf of the Customer.
            </li>
            <li>
              <b>Types of Personal Data:</b> Name, contact details, employment
              history, education, skills, video/audio interview recordings, and
              any other data contained within a resume or candidate profile.
            </li>
            <li>
              <b>Categories of Data Subjects:</b> Job applicants and potential
              candidates of the Customer.
            </li>
          </ul>
          <p className="py-4">3. Obligations of the Provider (Processor)</p>
          <p className="mb-4">Provider agrees to:</p>
          <p className="mb-3">
            <b>3.1.</b> Process Personal Data only on the documented
            instructions of the Customer (as set forth in the Agreement and this
            DPA).
          </p>
          <p className="mb-3">
            <b>3.2.</b> Ensure that all personnel authorized to process Personal
            Data are bound by strict obligations of confidentiality.
          </p>
          <p className="mb-3">
            <b>3.3.</b> Implement and maintain appropriate technical and
            organizational security measures to protect Personal Data against
            unauthorized or unlawful processing and against accidental loss,
            destruction, or damage.
          </p>
          <p className="mb-2">
            <b>3.4. Sub-processors:</b>
          </p>
          <ul className="list-disc pl-6 mb-3 space-y-1">
            <li>
              Customer provides general authorization for Provider to engage
              third-party sub-processors (e.g., cloud infrastructure providers
              like AWS/Azure).
            </li>
            <li>
              Provider will maintain a list of its sub-processors and notify
              Customer of any new or replacement sub-processors, giving Customer
              an opportunity to object.
            </li>
          </ul>
          <p className="mb-3">
            <b>3.5. Data Subject Rights:</b> Provider will, to the extent
            legally permitted, provide reasonable assistance to Customer to
            respond to requests from Data Subjects exercising their rights
            (e.g., access, rectification, erasure).
          </p>
          <p className="mb-3">
            <b>3.6. Data Breach:</b> Provider will notify Customer without undue
            delay upon becoming aware of a personal data breach affecting
            Customer's Personal Data.
          </p>
          <p>
            <b>3.7. Data Deletion:</b> Upon termination of the Agreement,
            Provider will delete or return all Customer Personal Data in its
            possession within [e.g., 90] days, in accordance with its data
            retention policy.
          </p>
          <p className="py-4">
            4. Obligations of the Customer & 5. International Transfers
          </p>
          <h3 className="mb-3">4. Obligations of the Customer (Controller)</h3>
          <p className="mb-6">
            Customer warrants that it has obtained all necessary consents and
            provided all necessary notices for the lawful processing of Personal
            Data by Provider as described in this DPA.
          </p>
          <h3 className="mb-3">5. International Transfers</h3>
          <p>
            Customer acknowledges that the processing may take place in various
            locations globally. Provider will ensure that all transfers of
            Personal Data are made in accordance with applicable Data Protection
            Laws.
          </p>
        </>
      ),
    },
  ];

  return (
    <PageLayout>
      <div className="w-full">
        <div className="bg-white rounded-[10px] shadow-sm mb-5">
          <div className="text-center py-3">
            <h2 className="mb-2 text-[20px] md:text-[35px] font-[500] text-center">
              {termsContent?.map((item) => item?.title)}
            </h2>
          </div>
          <div className="text-gray-700 leading-relaxed">
            {termsContent?.map((item) => item?.content)}
          </div>
        </div>
      </div>
    </PageLayout>
  );
};

export default DataProcessingAddendum;
